enum ShippingCarriersEnum {
    UPS = 1,
    FEDEX = 2,
    USPS = 3,
    TNT = 4,
    DHL = 5,
    THREEPL = 6,
    LOCAL = 7,
}

export default ShippingCarriersEnum;
